<template>
  <div v-if="payment" class="container invoice-table">

    <br>
    <h5 class="row justify-content-center">
      <span style="margin-right: 15px" class="float-left">Платеж № {{ this.$route.params.id }}  </span>
    </h5>
    <br>

    <p v-if="message" class="float-left text-danger" style="margin-top: 8px; margin-left: 6px">
      <strong>{{ message }}</strong>
    </p>
    <div>
      <table class="table table-sm text-left">
        <tbody>
        <tr>
          <td class="table-td">id</td>
          <td>{{ payment.ID }}</td>
        </tr>
        <tr>
          <td class="table-td">Получатель</td>
          <td>{{ payment.RecipientName }}</td>
        </tr>
        <tr>
          <td class="table-td">Плательщик</td>
          <td>{{ payment.SenderName }} (ИНН {{ payment.SenderTaxID }})
          </td>
        </tr>
        <tr>
          <td class="table-td">Номер</td>
          <td>{{ payment.Number }}</td>
        </tr>
        <tr>
          <td class="table-td">Дата</td>
          <td>{{ payment.Date.toISOString().split('T')[0] }}</td>
        </tr>
        <tr>
          <td class="table-td">Сумма</td>
          <td v-bind:class="canBeProcessed ? '' : 'table-danger'">{{ payment.Amount }}</td>
        </tr>
        <tr>
          <td class="table-td">Назначение платежа</td>
          <td>{{ payment.Purpose }}</td>
        </tr>
        <tr>
          <td class="table-td">Комментарий</td>
          <td v-if="!commentEditEnabled" @click="commentEditEnabled = true" class="cursor-pointer">{{
              payment.Comment
            }}
          </td>
          <td v-else>
            <input style="width: 800px"
                   v-model=" payment.Comment"
                   @change="saveComment(payment)"
                   @blur="saveComment(payment)"
                   type="text"/>
          </td>
        </tr>
        <tr>
          <td class="table-td">Avis</td>
          <td>
            <span v-if="this.paymentAvisFile">
                      <button class="btn btn-outline-primary btn-download"
                              v-bind:class="this.isPaymentAvisDownloadError ? 'btn-outline-danger' : 'btn-outline-primary'"
                              @click="downloadPaymentAvis"
                              :disabled="this.paymentAvisDisabled">
          <span v-if="!this.paymentAvisDisabled">Avis</span>
          <span v-if="this.paymentAvisDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
            </span>
            <span style="width: 10px;padding-right: 20px"></span>
            <span v-if="!isFilePrepared"><input type="file" @change="OnFileChanged"></span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="canBeReverted" class="float-left>">
      <br>
      <button v-if="canBeReverted" class="btn btn-outline-primary btn-download float-left"
              v-bind:class="isProcessError ? 'btn-outline-danger' : 'btn-outline-primary'"
              @click="paymentReconcileRollback"
              :disabled="(!canBeReverted)">
        <span v-if="!waiting">Отменить разнесение</span>
        <span v-if="waiting"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true">
            </span>
      </button>
      <br>
      <br>
      <br>
    </div>

    <br>
    <h5 class="row justify-content-left">
      <span style="margin-left: 20px" class="float-left">Расшифровка платежа</span>
    </h5>
    <br>

    <p class="text-left">
      Cash discount: <input v-model="cashDiscount"
                            @change="applyCashDiscount()"
                            type="number"
                            style="width: 50px"
                            class="text-right  no-spin"/> %
    </p>

    <p class="text-left">
      Diff: {{ amountLeftWithVat }}
    </p>

    <div v-if="isLoading">
      <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true">
      </span>
    </div>
    <div v-if="!isLoading">
      <table class="table text-left">
        <thead>
        <th style="width: 190px">УПД</th>
        <th class="text-right" style="width: 120px">Долг с НДС</th>
        <th class="text-right" style="width: 120px">Оплата с НДС</th>
        <th class="text-right" style="width: 120px">Оплата без НДС</th>
        <th class="text-right" style="width: 120px">Сумма УПД без НДС</th>
        <th></th>
        </thead>
        <tbody>
        <tr v-if="isEditable">
          <td>
          </td>
          <td></td>
          <td class="text-right" v-bind:class="canBeProcessed ? '' : 'table-danger'">{{
              new
              Intl.NumberFormat('ru-ru', {
                minimumFractionDigits:
                    2
              }).format(amountWithVat.toFixed(2))
            }}
          </td>
          <td class="text-right">{{
              new Intl.NumberFormat('ru-ru', {
                minimumFractionDigits:
                    2
              }).format(amount.toFixed(2))
            }}
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr v-for="(pt,p_idx) in payment.items">
          <td v-if="isEditable && pt.PaymentTransactionDocument == null">
            <v-select placeholder="< invoice >"
                      label="Number"
                      :filterable="true"
                      :clearable="true"
                      @input="(invoice) => onInvoiceInput(p_idx, invoice)"
                      @search="onInvoiceSearch"
                      :value="invoice"
                      :options="invoices"
                      style="width: 170px">
            </v-select>
          </td>
          <td v-else>
            <span v-if="pt.PaymentTransactionDocument.Code == 'invoice'">
                        <router-link :to="{name: 'invoiceItem', params:{
                            doc_id: pt.PaymentTransactionDocument.ExternalID,
                            countryID: pt.PaymentTransactionDocument.CountryID,
                        }}">{{ pt.PaymentTransactionDocument.Number }}
                        </router-link>
            </span>
            <span v-else>
              {{ pt.PaymentTransactionDocument.Number }}
            </span>
            <td class="text-right">
              <div v-if="pt.PaymentTransactionDocument">{{
                  new Intl.NumberFormat('ru-ru', {
                    minimumFractionDigits:
                        2
                  }).format(pt.PaymentTransactionDocument.DebtAmount.toFixed(2))
                }}
              </div>
            </td>
            <td class="text-right" style="width: 100px">
              <div v-if="isEditable && pt.isEditable" style="width: 100px" @blur="pt.isEditable = false">
                <input v-model="pt.AmountWithVat"
                       @change="refresh(p_idx)"
                       :max="pt.PaymentTransactionDocument.DebtSum"
                       type="number"
                       style="width: 100px"
                       class="text-right  no-spin"/>
              </div>
              <div v-else class="cursor-pointer" style="width: 100px" @click="pt.isEditable = true">
                {{
                  new Intl.NumberFormat('ru-ru', {
                    minimumFractionDigits:
                        2
                  }).format(pt.AmountWithVat.toFixed(2))
                }}
              </div>
            </td>
            <td class="text-right">
              <div v-if="pt.PaymentTransactionDocument">{{
                  new Intl.NumberFormat('ru-ru', {
                    minimumFractionDigits:
                        2
                  }).format(pt.Amount.toFixed(2))
                }}
              </div>
            </td>
            <td class="text-right">
              <div v-if="pt.PaymentTransactionDocument">{{
                  new Intl.NumberFormat('ru-ru', {
                    minimumFractionDigits:
                        2
                  }).format(pt.PaymentTransactionDocument.AmountNet.toFixed(2))
                }}
              </div>
            </td>
            <td v-if="isEditable">
              <i @click="remove(p_idx)" class="fas fa-minus-circle cursor-pointer"></i>
            </td>
        </tr>
        <tr v-if="isEditable">
          <td>
            <i @click="add()" class="fas fa-plus-circle cursor-pointer"></i>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>

    <br>
    <button v-if="isEditable" class="btn btn-outline-primary btn-download float-left"
            v-bind:class="isProcessError ? 'btn-outline-danger' : 'btn-outline-primary'"
            @click="paymentProcess"
            :disabled="(!canBeProcessed)">
      <span v-if="!waiting">Разнести</span>
      <span v-if="waiting"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true">
            </span>
    </button>

  </div>
</template>

<script>
import axios from 'axios';
import {stringify} from "querystring";

function compare(a, b) {
  if (a.name.toLowerCase() < b.name.toLowerCase())
    return -1;
  if (a.name.toLowerCase() > b.name.toLowerCase())
    return 1;
  return 0;
}

export default {
  name: 'Payment',
  data() {
    return {
      payment: null,
      invoices: [],
      invoice: null,
      cashDiscount: 0,
      message: '',
      isProcessError: false,
      isLoading: true,
      waiting: false,
      commentEditEnabled: false,
      selectedFile: null,
      fileUploadDisabled: false,
      paymentAvisFile: null,
      paymentAvisDisabled: false,
      isPaymentAvisDownloadError: false,
      portalUrl: {
        "ru": "wowworks.ru",
        "by": "wowworks.by",
        "de": "de.wowworks.org",
      },

    };
  },

  beforeCreate() {

  },

  created() {
    this.init();

  },

  computed: {
    isEditable() {

      let editable = false;

      if (this.payment && this.payment.Status === "error") {
        editable = true;
        if (this.payment.CountryID === 'de' && !(this.$store.getters.isAdmin || this.$store.getters.isDocEditAllowed)) {
          editable = false;
        }
      }

      return editable;
    },
    amount() {
      let v = this.payment.items ? this.payment.items.map(el => el.Amount).reduce((a, b) => a + b, 0) : 0;
      return Math.round(v * 100) / 100;
    },
    amountWithVat() {
      let v = this.payment.items ? this.payment.items.map(el => Number(el.AmountWithVat)).reduce((a, b) => a + b, 0) : 0;
      return Math.round(v * 100) / 100;
    },
    amountLeftWithVat() {
      return Math.round((Number(this.payment.Amount) - this.amountWithVat) * 100) / 100;
    },
    canBeProcessed() {
      let amount_with_vat = this.payment.items ? this.payment.items.map(el => el.AmountWithVat).reduce((a, b) => a + b, 0) : 0;
      return Math.round(Number(this.payment.Amount) * 100) == Math.round(Number(amount_with_vat) * 100);
    },
    isFilePrepared() {
      return this.selectedFile !== null;
    },
    isFileUploadDisabled() {
      return this.fileUploadDisabled;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    canBeReverted() {
      return this.isAdmin;
    },

  },

  methods: {
    init() {
      axios.get(`/payment`, {
        params: {
          id: this.$route.params.id,
        },
      })
          .then((res) => {
            console.log(res.data);

            res.data.Date = new Date(res.data.Date);

            let items = res.data.items;
            this.$delete(res.data, 'items')

            this.payment = res.data;
            document.title = this.payment ? this.payment.ID.toString() : '';

            if (this.payment.AmountCorrected > 0) {
              this.payment.Amount = this.payment.AmountCorrected
            }

            this.$set(this.payment, 'items', []);

            if (items && items.length > 0) {
              items.forEach(item => {
                item.isEditable = false;
                item.maxValue = item.AmountWithVat;
                this.payment.items.push(item);
              })
            }

            this.getPaymentAvisFile();

            // this.getPaymentInvoices();
            this.isLoading = false;

          })
          .catch(error => console.log(error));


    },

    add() {
      let item = {
        ID: 0,
        PaymentID: 0,
        InvoiceID: 0,
        AmountWithVat: 0,
        VatRate: 0,
        VatAmount: 0,
        Amount: 0,
        Status: "prepared",
        ProcessType: "regular",
        isEditable: false,
        maxValue: 0,
        Invoice: null,
      };

      if (this.payment.items == null) {
        this.payment.items = [];
      }

      this.payment.items.push(item);
    },

    remove(idx) {

      if (this.payment.items[idx].PaymentTransactionDocument) {
        this.invoices.push(this.payment.items[idx].PaymentTransactionDocument);

        this.payment.items.forEach(el => {

        });
      }
      this.paymentTransactionDelete(this.payment.items[idx]);

      this.payment.items.splice(idx, 1);

    },

    getPaymentInvoices() {
      axios.get(`/payment_invoices`, {
        params: {
          id: this.payment.ID,
        },
      })
          .then((res) => {
            // console.log(res.data);

            let invoices = res.data;
            console.log(invoices);
            this.isLoading = false;

            if (invoices) {
              invoices.forEach(inv => {
                inv.number = inv.number.String;
                if (!this.payment.items) {
                  this.invoices.push(inv);
                } else {
                  let idx_invoices = this.payment.items.findIndex(el => el.invoice_id === inv.id);
                  if (idx_invoices < 0) {
                    this.invoices.push(inv);
                  }
                }
              });
            }
          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });

    },

    onInvoiceSearch(search, loading) {
      // loading(true);

      // if (search.length === 0) {
      //     this.invoices = [];
      // }


      if (search.length > 3) {
        axios.get(`/payment_invoices`, {
          params: {
            id: this.payment.ID,
            number: search,
          },
        })
            .then((res) => {
              this.invoices.splice(0);
              if (res.data == 'null') {
                this.invoices.splice(0);
              } else {
                let invoices = res.data;
                console.log(invoices);
                this.isLoading = false;

                if (invoices) {
                  invoices.forEach(inv => {
                    inv.number = inv.number.String;
                    if (!this.payment.items) {
                      this.invoices.push({
                        AmountGross: inv.summ,
                        AmountNet: inv.amount_with_vat,
                        Code: "invoice",
                        CountryID: inv.country_id,
                        DebtAmount: inv.debt_sum,
                        ExternalID: inv.external_id,
                        ID: inv.id,
                        Number: inv.number,
                        PaymentAmount: inv.payment_amount,
                        UUID: inv.uuid,
                        VatAmount: inv.vat_amount,
                        VatRate: inv.vat_rate,
                      });
                    } else {
                      let idx_invoices = this.payment.items.findIndex(el => el.invoice_id === inv.id);
                      if (idx_invoices < 0) {
                        this.invoices.push({
                          AmountGross: inv.summ,
                          AmountNet: inv.amount_with_vat,
                          Code: "invoice",
                          CountryID: inv.country_id,
                          DebtAmount: inv.debt_sum,
                          ExternalID: inv.external_id,
                          ID: inv.id,
                          Number: inv.number,
                          PaymentAmount: inv.payment_amount,
                          UUID: inv.uuid,
                          VatAmount: inv.vat_amount,
                          VatRate: inv.vat_rate,
                        });
                      }
                    }
                  });
                }
              }
            })
            .catch((error) => {
              console.log(error);
              console.log(error.response);
              this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
              this.invoices = [];
            });
      }
    },


    onInvoiceInput(p_idx, inv) {

      console.log("value=" + stringify(inv));
      console.log("p_idx=" + p_idx);
      // console.log("invoice=" + invoice);

      this.payment.items[p_idx].PaymentTransactionDocument = inv;

      console.log("this.payment.items[p_idx].PaymentTransactionDocument=" + this.payment.items[p_idx].PaymentTransactionDocument);
      console.log("this.payment.items[p_idx].PaymentTransactionDocument.id=" + this.payment.items[p_idx].PaymentTransactionDocument.ID);

      let amount_with_vat = Math.round(this.payment.items[p_idx].PaymentTransactionDocument.DebtAmount * 100) / 100;
      let vat_rate = this.payment.items[p_idx].PaymentTransactionDocument.VatRate;
      let vat_amount = Math.round(amount_with_vat * vat_rate * 100 / (1 + vat_rate)) / 100;
      let amount = amount_with_vat - vat_amount;

      console.log("amount_with_vat = " + amount_with_vat);
      console.log("vat_rate = " + vat_rate);
      console.log("vat_amount = " + vat_amount);
      console.log("amount = " + amount);

      if (this.payment.items[p_idx].PaymentTransactionDocument.DebtSum === this.payment.items[p_idx].PaymentTransactionDocument.AmountGross) {
        amount_with_vat = this.payment.items[p_idx].PaymentTransactionDocument.AmountGross;
        vat_rate = this.payment.items[p_idx].PaymentTransactionDocument.VatRate;
        vat_amount = this.payment.items[p_idx].PaymentTransactionDocument.VatAmount;
        amount = this.payment.items[p_idx].PaymentTransactionDocument.AmountNet;
      }

      console.log("amount_with_vat = " + amount_with_vat);
      console.log("vat_rate = " + vat_rate);
      console.log("vat_amount = " + vat_amount);
      console.log("amount = " + amount);

      this.payment.items[p_idx].AmountWithVat = amount_with_vat;
      this.payment.items[p_idx].VatRate = vat_rate;
      this.payment.items[p_idx].VatAmount = vat_amount;
      this.payment.items[p_idx].Amount = amount;

      this.payment.items[p_idx].InvoiceID = this.payment.items[p_idx].PaymentTransactionDocument.ID;
      this.payment.items[p_idx].RelatedEntityUUID = this.payment.items[p_idx].PaymentTransactionDocument.UUID;
      this.payment.items[p_idx].PaymentID = this.payment.ID;

      this.payment.items[p_idx].isEditable = false;
      this.payment.items[p_idx].maxValue = Number(this.payment.items[p_idx].AmountWithVat);

      let idx_invoices = this.invoices.findIndex(el3 => el3.id === this.payment.items[p_idx].PaymentTransactionDocument.ID);
      if (idx_invoices >= 0) {
        this.invoices.splice(idx_invoices, 1);
      }

      console.log("this.payment.items[p_idx] = " + stringify(this.payment.items[p_idx]));


      this.paymentTransactionSave(this.payment.items[p_idx]);
    },

    paymentTransactionSave(t) {

      axios.post(`/payment/${t.PaymentID}/transaction-save`, t)
          .then((response) => {
            console.log(response.data);
            t.ID = response.data.ID;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.waiting = false;
          });
    },


    paymentTransactionDelete(t) {

      if (t.ID === 0) {
        return
      }

      axios.delete(`/payment/${t.PaymentID}/transaction-delete`, {
        params: {
          'id': t.ID
        }
      })
          .then((response) => {

          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.waiting = false;
          });
    },

    refresh(p_idx) {

      this.payment.items[p_idx].isEditable = false;

      this.payment.items[p_idx].AmountWithVat = Number(this.payment.items[p_idx].AmountWithVat);

      console.log(" this.payment.items[p_idx].AmountWithVat = " + this.payment.items[p_idx].AmountWithVat);


      if (this.payment.items[p_idx].AmountWithVat > this.payment.items[p_idx].maxValue) {
        this.payment.items[p_idx].AmountWithVat = Number(this.payment.items[p_idx].maxValue);
      }

      let amount_with_vat = this.payment.items[p_idx].AmountWithVat;
      let vat_rate = this.payment.items[p_idx].VatRate;
      let vat_amount = Math.round(amount_with_vat * vat_rate * 100 / (1 + vat_rate)) / 100;
      let amount = amount_with_vat - vat_amount;

      console.log("amount_with_vat = " + amount_with_vat);
      console.log("vat_rate = " + vat_rate);
      console.log("vat_amount = " + vat_amount);
      console.log("amount = " + amount);

      this.payment.items[p_idx].AmountWithVat = amount_with_vat;
      this.payment.items[p_idx].VatRate = vat_rate;
      this.payment.items[p_idx].VatAmount = vat_amount;
      this.payment.items[p_idx].Amount = amount;

      this.paymentTransactionSave(this.payment.items[p_idx]);
    },

    makeEditable(p_idx) {

      console.log("makeEditable(p_idx)");
      console.log(p_idx);
      this.payment.items[p_idx].isEditable = true;

      console.log(this.payment.items[p_idx].isEditable);

    },

    applyCashDiscount() {

      this.payment.items.forEach(
          item => {
            item.AmountWithVat = Math.round(Number(item.AmountWithVat * (100 - this.cashDiscount) / 100) * 100) / 100
            item.Amount = Math.round(item.AmountWithVat * 100 / (1 + item.VatRate)) / 100;

            this.paymentTransactionSave(item);

          }
      );

    },


    OnFileChanged(event) {
      this.selectedFile = event.target.files[0];
      this.FileUpload();
    },

    FileUpload() {
      const params = new FormData()
      params.set('docType', 'avis');
      params.append('file', this.selectedFile, this.selectedFile.name);

      this.fileUploadDisabled = true;
      axios.post(`/payment/${this.payment.ID}/file-upload`, params)

          .then((res) => {
            console.log(res.data);
            this.getPaymentAvisFile();
            this.selectedFile = null;
            this.fileUploadDisabled = false;
          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });
    },

    getPaymentAvisFile() {
      axios.get(`/payment/${this.payment.ID}/file`, {
        params: {
          docType: 'avis',
        },
      })
          .then((res) => {
            // console.log(res.data);
            this.paymentAvisFile = res.data;
            //console.log(this.contracts);

          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });
    },

    downloadPaymentAvis() {
      this.paymentAvisDisabled = true;
      this.isPaymentAvisDownloadError = false;
      axios.get(`/payment/${this.payment.ID}/download?type=avis`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `avis-${this.payment.ID}.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isPaymentAvisDownloadError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.paymentAvisDisabled = false;
          });
    },

    paymentProcess() {

      this.message = '';
      this.waiting = true;

      axios.post(`payment_process_one`, {
        paymentID: this.payment.ID,
      })
          .then((response) => {
            this.payment.Status = "reconciled";
            this.init();

          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.waiting = false;
          });
    },

    paymentReconcileRollback() {

      this.message = '';
      this.waiting = true;

      axios.post(`payment_reconcile_rollback`, {
        paymentID: this.payment.ID,
      })
          .then((response) => {
            this.init();
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.waiting = false;
          });
    },

    saveComment(p) {

      axios.put(`/payment/${p.ID}/update_comment`, {
        comment: p.Comment,
      })
          .then((response) => {
            this.commentEditEnabled = false;
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.commentEditEnabled = false;
          });
    },


  },


}
;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.invoice-table {
  font-size: 14px;
}

.btn-download {
  margin-left: 15px;
  width: 140px;
}

.table-td {
  width: 280px;
}

.table-smm {
  width: 560px;
}
</style>
